// extracted by mini-css-extract-plugin
export default {"container":"Products_container__q2Isj","products":"Products_products__yofgq","menu":"Products_menu__2lZMt","list":"Products_list__3D4z2","product":"Products_product__vpkCm"};